const state = {
	
	isLoggedIn  : false,
	userId      : '',
	user        : '',
	storeId     : 0,
	store       : '',
	logout_btn  : 0,
	isAdmin     : 0,
	token       : '',
	userMenu    : [],
	custGroupId : 0,
	timeout     : 120000
	

}

const mutations = {

	'AUTH_STATUS_CHANGE' (state,user) {
		state.userId     = user.userId
		state.isLoggedIn = user.isLoggedIn
		state.user       = user.currentUser
		state.isAdmin    = user.isAdmin
		state.token      = user.token
		state.userMenu   = user.userMenu

	},
	'AUTH_STORE_ID' (state,value)
	{
		state.storeId = value
	},
	'AUTH_STORE_NAME' (state,value)
	{
		state.store = value
	},
	'AUTH_LOGOUT_BTN' (state,value)
	{
		state.logout_btn = value
	},
	'AUTH_STORE_CUST_GROUP' (state,value)
	{
		state.custGroupId = value
	},


}

const actions = {

}

const getters = {

	isLoggedIn: (state) => {
		return state.isLoggedIn;
	},
	userId: (state) =>{
		
		return state.userId
	},

	currentUser: (state) => 
	{

		return state.user
	},
	storeId    : (state) =>
	{
		return state.storeId
	},
	store      : (state) =>
	{
		return state.store
	},
	logoutBtn : (state) =>
	{
		return state.logout_btn
	},
	isAdmin   : (state) =>
	{
		return state.isAdmin
	},
	token    : (state) =>
	{
		return state.token
	},
	userMenu : (state) =>
	{
		return state.userMenu
	},
	custGroupId : (state) =>
	{
		return state.custGroupId
	},
	timeout : (state) =>
	{
		return state.timeout
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}
